module.exports = __webpack_public_path__ + "216f76c362f2a5493a61baba56ff08a3.png";